import { z } from 'zod';
import { AdminActionInput } from '../shared.js';
import { CursorQuery } from '../../common/pagination.js';
import { TicketStatus } from '../../help.js';
// ── support desk (FR-ADM-53…55) ───────────────────────────────────────────
export const AgentReplyInput = AdminActionInput.extend({
    body: z.string().trim().min(1).max(5_000),
    status: TicketStatus.optional(),
});
export const TicketQueueQuery = CursorQuery.extend({
    status: TicketStatus.optional(),
    assigneeId: z.string().optional(),
});
//# sourceMappingURL=schemas.js.map